import { createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-hot-toast';

const initialState = {
  ui: {
    loading: false,
    loadingPartner: false,
    cart: false,
    stats: {
      pageCount: 1,
    },
  },
  sellers: [],
  products: {},
  basket: [],
  data: [],
  delivery: [],
  cart: [],
  delivery_location: {},
};

export const productReducer = createSlice({
  name: 'product',
  initialState,
  reducers: {
    get_sellers_success: (state, { payload }) => {
      state.ui.loadingPartner = false;
      state.sellers = payload;
    },
    get_sellers_error: (state) => {
      state.ui.loadingPartner = false;
    },
    get_sellers: (state) => {
      state.ui.loadingPartner = true;
    },
    get_products: (state) => {
      state.ui.loadingPartner = true;
    },
    get_products_success: (state, { payload }) => {
      state.ui.loadingPartner = false;
      const { products, stats } = payload;
      state.data = products;
      state.ui.stats = {
        ...stats,
      };
    },
    get_products_error: (state) => {
      state.ui.loadingPartner = false;
    },
    get_product: (state) => {
      state.ui.loading = true;
    },
    get_product_success: (state, { payload }) => {
      state.ui.loading = false;
      state.products = payload;
    },
    get_product_error: (state) => {
      state.ui.loading = false;
    },
    get_sellers_locations_error: (state) => {
      state.ui.loadingPartner = false;
    },

    get_sellers_locations_success: (state, { payload }) => {
      state.ui.loadingPartner = false;
      const { locations } = payload;
      state.delivery = locations;
    },

    get_sellers_locations: (state) => {
      state.ui.loadingPartner = true;
    },
    add_product_basket: (state) => {
      state.ui.loadingPartner = true;
    },
    add_product_basket_error: (state) => {
      state.ui.loading = false;
    },
    add_product_basket_success: (state, { payload }) => {
      state.ui.loading = false;
      state.basket = payload;
    },
    get_cart: (state, { payload }) => {
      const product = JSON.parse(localStorage.getItem('basket')) || {};
      if (payload) {
        state.cart = product[payload];
      }
    },
    get_location: (state) => {
      const location = JSON.parse(localStorage.getItem('location')) || {};
      state.delivery_location = location;
    },
    add_product_to_cart: (state, payload) => {
      state.ui.loadingPartner = true;
      const products = payload.payload;
      const basket = JSON.parse(localStorage.getItem('basket')) || {};
      const partner = localStorage.getItem('partner_id');
      const cartItems = basket[partner] || [];

      const existingProductIndex = cartItems.findIndex(
        (item) => item._id === products._id && item.size === products.size,
      );

      if (existingProductIndex !== -1) {
        cartItems[existingProductIndex].quantity += products.quantity;
        toast.success(`${cartItems[existingProductIndex].name} updated!!`);
      } else {
        cartItems.push(products);
        toast.success(`${products.name} added to basket!!`);
      }

      const doc = {
        ...basket,
        [partner]: cartItems,
      };
      localStorage.setItem('basket', JSON.stringify(doc));
      state.cart = doc[partner];
      state.ui.loadingPartner = false;
    },
    remove_item_from_cart: (state, { payload }) => {
      const prev = JSON.parse(localStorage.getItem('basket')) || [];
      const partner = localStorage.getItem('partner_id');
      const cartItems = prev[partner];

      if (Array.isArray(cartItems) && cartItems.length > 0) {
        const existingProductIndex = cartItems.findIndex(
          (item) => item.product_id === payload,
        );

        if (existingProductIndex !== -1) {
          cartItems.splice(existingProductIndex, 1); // Remove the item at existingProductIndex
        }

        let doc = {
          ...prev,
          [partner]: cartItems,
        };

        localStorage.setItem('basket', JSON.stringify(doc));
        state.cart = doc[partner];
      }
    },
    update_product_quantity: (state, { payload }) => {
      const prev = JSON.parse(localStorage.getItem('basket')) || {};
      const partner = localStorage.getItem('partner_id');
      const cartItems = prev[partner];

      const findProductIndex = cartItems.findIndex(
        (item) => item._id === payload.indx,
      );
      if (findProductIndex !== -1) {
        cartItems[findProductIndex].quantity = payload.newQuantity;
      }
      let doc = {
        ...prev,
        [partner]: cartItems,
      };
      localStorage.setItem('basket', JSON.stringify(doc));
      state.cart = doc[partner];
    },
    select_delivery_location: (state, { payload }) => {
      localStorage.setItem('location', JSON.stringify(payload));
      state.delivery_location = payload;
      toast.success('Delivery region selected!');
    },
  },
});

// Action creators are generated for each case reducer function

export const {
  get_sellers_success,
  get_product,
  get_product_success,
  get_product_error,
  get_sellers_error,
  get_sellers,
  add_product_basket,
  add_product_basket_error,
  add_product_basket_success,
  add_product_to_cart,
  get_products_success,
  get_products_error,
  get_products,
  get_sellers_locations,
  get_sellers_locations_error,
  get_sellers_locations_success,
  get_cart,
  remove_item_from_cart,
  update_product_quantity,
  get_location,
  select_delivery_location,
} = productReducer.actions;

export default productReducer.reducer;
